'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var dancesPrefix = exports.dancesPrefix = function dancesPrefix() {
  return IFEIS_API_URI + '/api/dances';
};
var dancesPath = exports.dancesPath = ['setMusic', 'one'];

var dancesAreLoading = exports.dancesAreLoading = function dancesAreLoading(state) {
  return !state.getIn(dancesPath) || state.getIn(dancesPath.concat(['loading']));
};

var getDances = exports.getDances = function getDances(state) {
  return state.getIn(dancesPath);
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/setMusic/paths.js
// module id = 158
// module chunks = 0